import React, { useState } from "react";
import {
	AppBar,
	Box,
	Button,
	Container,
	Dialog,
	DialogContent,
	FormControlLabel,
	Grid,
	IconButton,
	Paper,
	Slide,
	Stack,
	styled,
	Switch,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	TextField,
	Toolbar,
	Tooltip,
	Typography, OutlinedInput, InputLabel, Alert, FormLabel, RadioGroup, Radio
} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';

import {
	DataGrid,
	GridToolbar,
	GridToolbarContainer,
	useGridApiEventHandler,
} from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import { useEffect } from "react";
import { isEmpty } from "lodash";
import OfferingTable from "./OfferingTable";
import Loader from "../../components/loader/Loader";
import { showLoading } from "../../redux/actions/collection.actions.";
import { useDispatch, useSelector } from "react-redux";
import AnimatedButton from "../../components/comman/buttons/buttons";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg";
import { toast } from "react-hot-toast";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export default function EditCollection(props) {
	const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
	const { loading } = useSelector((state) => state.collectionReducer);
	const dispatch = useDispatch();
	const [alertMessage, setAlertMessage] = useState("");

	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: "center",
		color: theme.palette.text.secondary,
	}));
	const {
		openEdit,
		setOpenEdit,
		// brands,
		// offers,
		// setnewCollection,
		// newCollection,
		// createCollection,
		editSingleCollection,
		collectionDetails,
		collections,
		selectColId,
		editCollectionResult
	} = props;
	let { alert } = props;
	const [checked, setChecked] = React.useState([]);
	const [checkedOffer, setCheckedOffer] = useState([]);
	const [offerbySource, setOfferbySource] = useState([]);
	const [error, setError] = useState({
		name_error: true,
		details_error: true,
		offer_error: true,
	});
	const [offerList, setOfferingList] = useState([]);
	const [offers, setOffers] = useState([]);
	const [selectedOffering, setSelectedOffering] = useState([]);
	const [selectedPriorityOffering, setSelectedPriorityOffering] = useState([]);
	const [showPriorityList, setShowPriorityList] = useState(false);
	const [editCollection, setEditCollection] = useState({});
	const [confirmUpdateOpen, setConfirmUpdateOpen] = useState(false);

	const handleTextFieldChange = (e) => {
		if (!isEmpty(e.target.value)) {
			if (e.target.id === "collection_name") {
				error.name_error = false;
			}
			if (e.target.id === "details") {
				error.details_error = false;
			}
		} else {
			if (e.target.id === "collection_name") {
				error.name_error = true;
			}
			if (e.target.id === "details") {
				error.details_error = true;
			}
		}
		const { name, value } = e.target;
		if (name === "is_locked") {
			setEditCollection({ ...editCollection, [name]: value });
		} else {
			setEditCollection({ ...editCollection, [e.target.id]: e.target.value });
		}
	};

	const setAlert = (status, message) => {
		alert = {
			status: status,
			message: message
		}
	};

	function collectionNameExists(collection_name) {
		let arr = collections.filter((item) => item.collection_name.toLowerCase().trim() === collection_name.toLowerCase().trim())
		if (arr.length > 0) {
			return true
		} else {
			return false
		}
	}

	const handleConfirmUpdate = () => {
		setConfirmUpdateOpen(false);
		handleEditClick();
	};

	const handleEditClick = async () => {

		const collection_id = selectColId?.collection_id;
		const { collection_name, details, offerings, is_locked } = editCollection;
		if (collection_name != collectionDetails[0]?.collection_name && collectionNameExists(collection_name)) {
			setAlertMessage("Collection name already exists.");
			toast("Collection name already exists.", { icon: "⚠️" });
			return
		}
		const body = JSON.stringify({ collection_name: collection_name, details: details, offerings: offerings, is_locked: is_locked });
		dispatch(showLoading(true));
		const response = await fetch(`${host}/api/v1/collections/${collection_id}`, {
			method: "PATCH", // GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				accessToken: localStorage.getItem("accessToken"),
			},
			body: body,
		});

		// if (response.ok) setAlert("success", "Collection updated successfully");
		if (response.ok) {
			editCollectionResult("success")
			toast.success("Collection updated successfully.");
			handleClose();
			dispatch(showLoading(false));
		}
		else {
			dispatch(showLoading(false));
			editCollectionResult("error")
			toast.error("Collection not updated, something went wrong!");
		}
	};

	const fetchOffers = async () => {

		const response = await fetch(`${host}/api/v1/offerings/`, {
			method: "GET" /* GET, POST, PUT, DELETE, etc. */,
			headers: {
				"Content-Type": "application/json",
				accessToken: localStorage.getItem("accessToken"),
			},
		}).catch((err) => {
			// console.log(err.mesage);
		});

		const json = await response.json();
		setOffers(json.data);


	};

	//regex for positive numbers only
	const regexPositiveNo = /^[0-9\b]+$/;
	function containsOnlyNumbers(str) {
		return /^\d+$/.test(str);
	}

	const handlePriorityChange = (offering_id, prevPriority, value, field) => {

		let arr = [];
		if (value <= 0 || isNaN(value) || !containsOnlyNumbers(value)) {
			arr = selectedPriorityOffering.map((item) => {
				if (item.offering_id == offering_id) {
					item.priority = item.priority
				}
				return item;
			});
			setSelectedPriorityOffering(arr);
			return
		}
		let alreadyExist = selectedPriorityOffering.find((item) => field !== 'price' && item.priority == value);
		if (alreadyExist) {
			if (window.confirm(`Priority ${value} already assigned. Do you want to update?`)) {
				console.log("continue..");
			} else {
				setSelectedPriorityOffering([...selectedPriorityOffering]);
				return
			}
		}
		arr = selectedPriorityOffering.map((item) => {
			if (field !== 'price') {
				if ((item.offering_id != offering_id) && (item.priority == value)) {
					item.priority = '-1'
				}
				if (item.offering_id == offering_id) {
					item.priority = `${value}`
				}
				return item;
			} else {

				if (item.offering_id == offering_id) {
					item.price = `${value}`
				}
				return item;
			}

		});

		setSelectedPriorityOffering(arr);
	}

	let columns = [
		{ field: "id", headerName: "ID", width: 90 },
		{
			field: "brand_name",
			headerName: "Brand Name",
			sortable: true,
			width: 200,
		},
		{
			field: "discount",
			headerName: "Discount",
			sortable: false,
			width: 80,
			editable: false,
		},
		{
			field: "priority",
			headerName: "Priority",
			sortable: false,
			width: 80,
			editable: false,
		},
		{
			field: "price",
			headerName: "price",
			sortable: false,
			width: 80,
			editable: false,
		},
		{
			field: "discount_type",
			headerName: "Discount Type",
			sortable: true,
			width: 120,
		},
		{
			field: "type",
			headerName: "Type",
			sortable: true,
			width: 150,
			editable: false,
		},
		{
			field: "details",
			headerName: "Details",
			sortable: true,
			width: 250,
			editable: true,
		},
		{
			field: "validity",
			headerName: "Validity",
			type: "dateTime",
			sortable: true,
			width: 200,
			editable: true,
		},
		{
			field: "tags",
			headerName: "Tags",
			sortable: true,
			width: 200,
			editable: true,
		},
		{
			field: "status",
			headerName: "Status",
			sortable: true,
			width: 100,
			editable: true,
		}

	];

	let columnsPriority = [
		{ field: "id", headerName: "ID", width: 90 },
		{
			field: "brand_name",
			headerName: "Brand Name",
			sortable: true,
			width: 200,
		},
		{
			field: "priority",
			headerName: "Priority",
			sortable: true,
			editable: true,
			width: 100,
		},
		{
			field: "price",
			headerName: "price",
			sortable: true,
			editable: true,
			width: 100,
		},
		{
			field: "discount",
			headerName: "Discount",
			sortable: false,
			width: 80,
			editable: false,
		},
		{
			field: "discount_type",
			headerName: "Discount Type",
			sortable: true,
			width: 120,
		},
		{
			field: "type",
			headerName: "Type",
			sortable: true,
			width: 150,
			editable: false,
		},
		{
			field: "details",
			headerName: "Details",
			sortable: true,
			width: 250,
			editable: false,
		},
		{
			field: "validity",
			headerName: "Validity",
			type: "dateTime",
			sortable: true,
			width: 200,
			editable: false,
		},
		{
			field: "tags",
			headerName: "Tags",
			sortable: true,
			width: 200,
			editable: false,
		},
		{
			field: "status",
			headerName: "Status",
			sortable: true,
			width: 100,
			editable: false,
		}

	];

	// const rows = offers.map((offer) => {
	// 	return {
	// 		id: offer.offering_id,
	// 		discount_type: offer.discount_type,
	// 		discount: offer.discount,
	// 		type: offer.type,
	// 		// tag: offer.tag,
	// 		validity: offer.validity
	// 			? new Date(offer.validity).toLocaleString({ timeZone: "Asia/Kolkata" })
	// 			: offer.validity,
	// 		brand_name: offer.brand_name,
	// 		// coin: offer.coin,
	// 		created_at: offer.created_at,
	// 		details: offer.details,
	// 		tags: offer.tag.map(obj => obj.name).join(', '),
	// 		status: offer.status ? "Active" : "Inactive"
	// 	}
	// });

	function getRows() {
		// console.log("offers", offers[0]);
		let arr = offers.map((offer) => {

			return {
				id: offer.offering_id,
				discount_type: offer.discount_type,
				discount: offer.discount,
				type: offer.type,
				// tag: offer.tag,
				validity: offer.validity
					? new Date(offer.validity).toLocaleString({ timeZone: "Asia/Kolkata" })
					: offer.validity,
				brand_name: offer.brand_name,
				// coin: offer.coin,
				created_at: offer.created_at,
				details: offer.details,
				tags: offer.tag.map(obj => obj.name).join(', '),
				status: offer.status ? "Active" : "Inactive",
				price: (offers && collectionDetails) ? selectedPriorityOffering.find((obj) => obj.offering_id == offer.offering_id)?.price : '0',
				priority: (offers && collectionDetails) ? selectedPriorityOffering.find((obj) => obj.offering_id == offer.offering_id)?.priority : '-1'
			}
		});
		return [
			...arr.filter((obj) => (selectedOffering.indexOf(obj.id) !== -1)),
			...arr.filter((obj) => (selectedOffering.indexOf(obj.id) === -1)),
		]
	}

	function getPriorityRows() {
		if (selectedPriorityOffering.length <= 0) {
			return []
		}
		let arr = selectedPriorityOffering.map((item) => {
			let offer = offers.find((obj) => obj.offering_id == item.offering_id);
			if (offer) {
				return {
					id: offer.offering_id,
					discount_type: offer.discount_type,
					discount: offer.discount,
					type: offer.type,
					// tag: offer.tag,
					validity: offer.validity
						? new Date(offer.validity).toLocaleString({ timeZone: "Asia/Kolkata" })
						: offer.validity,
					brand_name: offer.brand_name,
					// coin: offer.coin,
					created_at: offer.created_at,
					details: offer.details,
					tags: offer.tag.map(obj => obj.name).join(', '),
					status: offer.status ? "Active" : "Inactive",
					priority: item.priority ?? "-1",
					price: item.price ?? '0'
				}
			}
		});
		return [
			...arr.filter((obj) => obj.priority != '-1').sort((a, b) => { return parseInt(a.priority) - parseInt(b.priority) }),
			...arr.filter((obj) => obj.priority == '-1')
		]
	}

	const handleClose = () => {
		setAlertMessage("")
		setOpenEdit(false);
		setChecked([]);
		// setnewCollection([]);
		setShowPriorityList(false);
		setCheckedOffer([]);
		setSelectedOffering([]);
		setSelectedPriorityOffering([]);
	};

	const handleSelect = (e) => {
		let updatedSelectedList = e.map((id) => {
			let objfromSelectedPriority = selectedPriorityOffering.find((obj) => obj.offering_id == id);
			if (objfromSelectedPriority) {
				return objfromSelectedPriority;
			} else {
				let obj = offers.find((offer) => offer.offering_id == id);
				if (obj) {
					return {
						"offering_id": obj.offering_id,
						"priority": "-1",
					}
				}
			}
		});
		setSelectedOffering(e);
		setSelectedPriorityOffering(updatedSelectedList);
		setEditCollection({ ...editCollection, ["offerings"]: updatedSelectedList });
		// setEditCollection({ ...editCollection, ["offerings"]: e });
	}
	const handlePrioritization = () => {
		setShowPriorityList(!showPriorityList);
	}
	useEffect(() => {
		setAlertMessage("");
		if (collectionDetails) {
			let data = collectionDetails.map((e) => e.offering_id);
			let priorityData = collectionDetails.map((e) => { return { 'offering_id': e.offering_id, 'priority': e.priority, 'price': e.price ?? '0' } });
			setSelectedOffering(data);
			setSelectedPriorityOffering(priorityData);
			setEditCollection({ ...editCollection, ["offerings"]: priorityData });
			let is_locked;
			if (collectionDetails[0]?.is_locked) is_locked = "true";
			if (!collectionDetails[0]?.is_locked) is_locked = "false";

			setEditCollection({
				...editCollection,
				collection_id: collectionDetails[0]?.collection_id,
				collection_name: collectionDetails[0]?.collection_name,
				details: collectionDetails[0]?.collection_details,
				is_locked: is_locked,
				offerings: priorityData
			});
			// setEditCollection({ ...editCollection, ["offerings"]: data });
			// setEditCollection({
			// 	...editCollection,
			// 	collection_id: collectionDetails[0]?.collection_id,
			// 	collection_name: collectionDetails[0]?.collection_name,
			// 	details: collectionDetails[0]?.collection_details,
			// 	offerings: data
			// });
			error.name_error = false;
			error.details_error = false;
		}
	}, [collectionDetails]);

	useEffect(() => {
		setAlertMessage("");
		fetchOffers();
	}, []);

	return (<>
		<Dialog
			open={openEdit}
			onClose={handleClose}
			TransitionComponent={Transition}
			fullWidth
			maxWidth='xl'
			scroll='paper'
			PaperProps={{
				sx: {
					borderRadius: 3,
					overflow: "hidden",
					maxHeight: "92vh",
					border: "1px solid rgba(148, 163, 184, 0.35)",
					background: "#ffffff",
				},
			}}
			BackdropProps={{
				sx: {
					backdropFilter: "blur(6px)",
					backgroundColor: "rgba(2, 6, 23, 0.6)",
				},
			}}
		>
			<AppBar
				sx={{
					position: "relative",
					background:
						"linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
				}}
			>
				<Toolbar>
					<IconButton
						edge='start'
						color='inherit'
						onClick={handleClose}
						aria-label='close'>
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
						Edit Collection
					</Typography>
					{
						<AnimatedButton
							label={`Update Collection`}
							icon={<SaveIcon />}
							disabled={
								loading || error.details_error || error.name_error || !selectedOffering?.length > 0
							}
							onClick={() => {
								setConfirmUpdateOpen(true);
							}}
							sx={{
								background: 'linear-gradient(45deg, #ffffff 30%, #ffffff 90%)',
								color: 'black',
								cursor: 'pointer',
								'&:disabled': {
									backgroundColor: '#e0e0e0',
									color: '#9e9e9e',
								},
							}}
						/>
					}
				</Toolbar>
			</AppBar>
			<DialogContent
				dividers
				sx={{
					p: 0,
					overflowX: "hidden",
					overflowY: "auto",
					maxHeight: "calc(92vh - 64px)",
				}}
			>
				{alertMessage && (
					<Alert
						onClose={() => {
							setAlertMessage("");
						}}
						severity="error">
						{alertMessage}
					</Alert>
				)}
				{
					loading ? <Loader status={"Loading"} /> :
						(<>
						<Grid
							sx={{ margin: '0 auto', width: '90%' }}
							container
							spacing={2}
							justifyContent={"space-between"}
						>
							<Grid item xs={5.25}>
								<TextField
									required
									id='collection_name'
									// label='Collection'
									placeholder='Collection Name'
									value={editCollection.collection_name}
									onChange={handleTextFieldChange}
									sx={{ width: '100%' }}
								/>
							</Grid>
							<Grid item xs={5.25}>
								<TextField
									required
									id='details'
									// label='Details'
									placeholder='Details'
									multiline
									maxRows={4}
									value={editCollection.details}
									onChange={handleTextFieldChange}
									sx={{ width: '100%' }}
								/>
							</Grid>
							<div style={{ margin: "1rem 2rem" }}>
								<FormLabel component="legend">Type</FormLabel>
								<RadioGroup aria-label="type" id="type" name="is_locked" value={editCollection.is_locked} style={{ display: "flex", flexDirection: "row" }} onChange={handleTextFieldChange}>
									<FormControlLabel id="type" value={true} control={<Radio />} label="Locked" />
									<FormControlLabel id="type" value={false} control={<Radio />} label="Unlocked" />
								</RadioGroup>
							</div>
							<Grid item xs={1.5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
								<Button
									autoFocus
									variant="contained"
									sx={{ marginRight: '10px' }}
									disabled={
										loading || error.details_error || error.name_error || !selectedOffering?.length > 0
									}
									onClick={() => {
										handlePrioritization();
									}}>
									{showPriorityList ? "All Offers" : "Prioritize"}
								</Button>
							</Grid>
						</Grid>
						{/* <OfferingTable handleRowSelection={handleRowSelection} selectionModel={defaultSelection}/> */}
						<Box style={{ height: "79vh", width: "90%", margin: "20px auto" }}>
							{
								(!showPriorityList) ? <>
									<DataGrid
										columnVisibilityModel={{
											id: false,
											// source_business_id:false
										}}
										rowHeight={36}
										pageSize={15}
										rowsPerPageOptions={[10]}
										components={{
											Toolbar: GridToolbar,
										}}
										rows={getRows()}
										columns={columns}
										initialState={{ pinnedColumns: { right: ["actions"] } }}
										checkboxSelection

										onSelectionModelChange={(e) => handleSelect(e)}
										selectionModel={selectedOffering}
										sx={{
											'& [aria-label="Select all rows"], & [aria-label="Unselect all rows"]': {
												display: 'none',
												pointerEvents: 'none',
												opacity: 0.5, // optional visual cue before hiding
											},
											"& .MuiDataGrid-iconSeparator": {
												display: "none",
											},
											"& .MuiDataGrid-pinnedColumnHeaders": {
												boxShadow: "none",
												backgroundColor: "transparent",
											},
											"& .MuiDataGrid-pinnedColumns": {
												boxShadow: "none",
												backgroundColor: "transparent",
												"& .MuiDataGrid-cell": {
													padding: 0,
												},
											},
											"& .MuiDataGrid-row": {
												cursor: "pointer",
												"&:hover": {
													backgroundColor: "whitesmoke",
												},
												"&:first-child": {
													borderTop: "1px solid rgba(224, 224, 224, 1)",
												},
											},
											"& .MuiDataGrid-cell:focus": {
												outline: "none",
											},
											"& .MuiDataGrid-cell:focus-within": {
												outline: "none",
											},
										}}
									/>
								</> : <>
									<DataGrid
										columnVisibilityModel={{
											id: true,
											// source_business_id:false,
										}}
										rowHeight={36}
										pageSize={15}
										rowsPerPageOptions={[10]}
										components={{
											Toolbar: GridToolbar,
										}}
										rows={getPriorityRows()}
										columns={columnsPriority}
										initialState={{ pinnedColumns: { right: ["actions"] } }}
										onCellEditStop={(params, event) => {
											const field = params.field;
											const value = event.target.value;
											if (field === 'price') {
												handlePriorityChange(params.row.id, parseInt(params.row.price), value, field);
											} else {
												handlePriorityChange(params.row.id, parseInt(params.row.priority), value, field);
											}
										}}
										sx={{
											"& .MuiDataGrid-iconSeparator": {
												display: "none",
											},
											"& .MuiDataGrid-pinnedColumnHeaders": {
												boxShadow: "none",
												backgroundColor: "transparent",
											},
											"& .MuiDataGrid-pinnedColumns": {
												boxShadow: "none",
												backgroundColor: "transparent",
												"& .MuiDataGrid-cell": {
													padding: 0,
												},
											},
											"& .MuiDataGrid-row": {
												cursor: "pointer",
												"&:hover": {
													backgroundColor: "whitesmoke",
												},
												"&:first-child": {
													borderTop: "1px solid rgba(224, 224, 224, 1)",
												},
											},
											"& .MuiDataGrid-cell:focus": {
												outline: "none",
											},
											"& .MuiDataGrid-cell:focus-within": {
												outline: "none",
											},
										}}
									/>
								</>
							}
						</Box>
						</>)

				}
			</DialogContent>
		</Dialog>

		<MessageDialog
			open={confirmUpdateOpen}
			onClose={() => setConfirmUpdateOpen(false)}
			title="Update Collection"
			message={`Are you sure you want to update this collection ${editCollection.collection_name || ""}?`}
			okText="Update"
			variant="warning"
			onConfirm={handleConfirmUpdate}
		/>

	</>
	);
}
